import { ISvgProps } from '@src/types';

const Annotation = ({ width = '16px', height = '16px', fillColor = 'var(--font-color)', ...props }: ISvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 17" {...props}>
    <path
      stroke={fillColor}
      d="M14.604 5.602a2.05 2.05 0 0 0-2.894 0L5.837 11.47c-.312.314-1.181 1.387-1.245 1.824l-.315 2.21a1.302 1.302 0 0 0 1.472 1.474l2.21-.315c.438-.064 1.51-.933 1.825-1.245l5.872-5.873c.799-.8.799-2.095 0-2.895l-1.052-1.048ZM15.801 16.428h-5.208a.558.558 0 1 1 0-1.116H15.8a.558.558 0 1 1 0 1.116Z"
    />
    <path
      fill={fillColor}
      d="M4.275 13.451a.555.555 0 0 1-.262-.065 6.88 6.88 0 1 1 9.159-9.564.558.558 0 1 1-.962.567 5.764 5.764 0 1 0-7.672 8.012.558.558 0 0 1-.263 1.05Z"
    />
  </svg>
);
export default Annotation;
